import {WidgetContainerType, WidgetSize, WidgetStatus, WidgetType,} from "../interface/WidgetType";
import {SearchType} from "../interface/SearchType";
import {ModuleTree, RequireContextHelper} from "@/util/RequireContextHelper";
import _, {camelCase, set, upperFirst} from "lodash";
import {FieldType} from "../interface/FieldType";

/**
 * 表单组件元数据
 */
export interface WidgetMeta {
    size: Record<WidgetStatus, WidgetSize>;
}

/**
 * 定义表单元数据
 * @param param
 */
export function definedWidgetMeta(param?: {
    size?: Partial<WidgetMeta["size"]>;
}) {
    return {
        size: Object.assign(
            {
                edit: "small",
                show: "small",
            },
            param?.size
        ),
    }
}

/**
 * 组件信息，包括在不同容器下的组件实现及元数据
 */
interface WidgetInfo {
    form?: {
        meta: WidgetMeta
        component: any;
    }
    table?: {
        meta: WidgetMeta
        component: any;
    }
    search?: {
        meta: WidgetMeta
        component: any;
    }
}

type WidgetInfoMap = {
    [name in keyof WidgetType['name']]?: WidgetInfo;
}

function createWidgetInfoMap(tree: ModuleTree) {
    const map: WidgetInfoMap = {};
    if (!tree.files) {
        return;
    }
    const scenes: WidgetContainerType[] = ["form", "table", "search"];
    Object.values(tree.files)
        .map(file => {
            scenes.map(scene => {
                if (file.info.filename.endsWith(upperFirst(scene))) {
                    set(map, [camelCase(file.info.filename.slice(0, -scene.length)), scene], {
                        meta: file.module.meta || definedWidgetMeta(),
                        component: file.module.default,
                    });
                }
            })
        });
    return map;
}

let map: WidgetInfoMap | undefined = undefined;

export function getWidgetInfo<S extends WidgetContainerType, K extends WidgetType['name'] = 'search' extends S ? SearchType['name'] : FieldType['name']>
(scene: S, type: K): WidgetInfo[S] | undefined {
    if (!map) {
        map = createWidgetInfoMap(RequireContextHelper.toTree(
            require.context("./impl", false, /.*\.vue$/, "sync")
        ));
    }
    return _.get(map, [type, scene])
}

